import { csx } from '@vtex/admin-ui'

const styles = {
  field: csx({
    width: '100%',
    '[data-error="true"]': { border: '1px solid red' },
    '[data-disabled="true"]': {
      pointerEvents: 'none',
      background: '$disabled',
      input: {
        background: '$disabled',
      },
    },
    '[data-label="false"]': {
      '* > label + *': {
        paddingTop: 0,
      },
    },
  }),
  popover: csx({
    '[data-disabled="true"]': {
      pointerEvents: 'none',
      svg: {
        display: 'none',
      },
      '*': {
        '&&': {
          background: '$primary',
        },
      },
    },
  }),
  detailContainer: csx({
    width: '100%',
    display: 'flex',
    '> *': {
      paddingTop: '$space-1',
    },
  }),
  errorText: csx({ ':empty': { display: 'none' } }),
  counterText: csx({
    marginLeft: 'auto',
  }),
  helpText: csx({
    color: '$secondary',
    ':empty': { display: 'none' },
  }),
  optionIcon: csx({ marginRight: '$space-2' }),
  optionText: csx({
    width: 'full',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
  tag: csx({ overflowWrap: 'anywhere' }),
}

export default styles
